import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=e8a61434&"
import script from "./Backtop.vue?vue&type=script&lang=js&"
export * from "./Backtop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports